// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cG4GH","title":"styles_title__1xNWp"};